import React from "react";
import { useSetDeepLinkFromUrlParam } from "../../../hooks/useSetDeepLinkFromUrlParam";
import { useInitializeCustomBranding } from "../../../hooks/useInitializeCustomBranding";
import { AuthStatus } from "../../../enums";
import { useNavigateStore } from "../../../stepFlowHooks/useNavigateStore";
import { StepId } from "../../../enums/navigation";
import { ERROR_STATE } from "../../../constants";
import ErrorAlert from "../../../components/general/ErrorAlert";
import { useTranslation } from "react-i18next";
import { useSetCookiesFromUrlParam } from "./useSetCookiesFromUrlParam";
import { useSetDeviceTypeClass } from "./useSetDeviceTypeClass";
import { useTrackPageRefreshEvent } from "./useTrackPageRefreshEvent";
import { useCheckAuthErrorAlertOnInitStep } from "./useCheckAuthErrorAlertOnInitStep";
import { useCheckUserAuthentication } from "./useCheckUserAuthentication";
import { StepFlowGate } from "../../Navigator/StepFlowGate";

export const InitStep = () => {
    const { t } = useTranslation();
    const navigateToSignInStep = useNavigateStore(
        (store) => store.navigateToSignInStep
    );

    useSetDeviceTypeClass();
    useTrackPageRefreshEvent();

    const settingDeepLinkStatus = useSetDeepLinkFromUrlParam();
    const settingCookiesFromUrlParamsStatus = useSetCookiesFromUrlParam();
    const hasAuthError = useCheckAuthErrorAlertOnInitStep();
    const isCustomBrandingResourceReady = useInitializeCustomBranding();
    const authStatus = useCheckUserAuthentication();

    const isInitCompleted =
        settingCookiesFromUrlParamsStatus === "completed" &&
        settingDeepLinkStatus === "completed" &&
        isCustomBrandingResourceReady &&
        authStatus !== AuthStatus.LOADING;

    // TODO [LOWA-30534] From: https://tiny.amazon.com/ejfk5dzn
    if (isInitCompleted && hasAuthError) {
        return (
            <ErrorAlert
                type={ERROR_STATE.INFO}
                header={t("login.errorAlert.unauthorized.header")}
                message={t("login.errorAlert.unauthorized.message")}
                onDismissErrorAlert={navigateToSignInStep}
            />
        );
    }

    return (
        <StepFlowGate
            isCompleted={isInitCompleted}
            completedStepId={StepId.INIT}
        />
    );
};
